import $ from "jquery";
import { mobileNavToggler } from "./modules/_navbar.js"
import "./modules/_map"
import { SmoothScroll } from "./modules/_smooth-scroll"
import { isMobDevice } from "./modules/_helpers"
import AOS from "aos";
import setupSubscribePopup from "./modules/_subscribe-popup";

const protectImages = function () {
  let imageEl = document.querySelectorAll('img');
  let imageWrapper = document.querySelectorAll('.wp-block-image');
  if(imageEl.length > 0) {
    for(let a = 0; a < imageEl.length; a++) {
      imageEl[a].setAttribute('oncontextmenu','return false;');
    }
  }
  if(imageWrapper.length > 0) {
    for(let a = 0; a < imageWrapper.length; a++) {
      imageWrapper[a].setAttribute('oncontextmenu','return false;');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
    mobileNavToggler().init();
    protectImages();
    setupSubscribePopup();

    AOS.init({ 
      disable: "mobile",
      duration: 800,
    });
    
    if ( !isMobDevice() ) {
        SmoothScroll()
    }

    let anchorHash = window.location.href.toString()
    if(anchorHash.lastIndexOf('#') !== -1) {
      anchorHash = anchorHash.substr(anchorHash.lastIndexOf('#'))
      console.log(anchorHash)
      document.getElementById(anchorHash.replace('#', '')).click()
    }

    $(document).on('scroll', function () {
      const y = $(this).scrollTop();
      if (y > 500) {
          $('.top-button').css('opacity', '1');
      } else {
          $('.top-button').css('opacity', '0');
      }
    });

    $('.top-button').on('touch click', function () {
      $("html, body").animate({
          scrollTop: 0,
      }, 1500);
      return false;
    });

    $(".map-button").on('touch click', function () {
      $('body').addClass('popup-open');
      $(".map-popup").addClass('open');
    }); 

    $(".map-popup__overlay, .close-map").on('touch click', function () {
      $('body').removeClass('popup-open');
      $(".map-popup").removeClass('open');
    });
});

window.addEventListener('resize', () => {
  AOS.init({ disable: "mobile" });
});
